// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper__k72vJ","rightZone":"Wrapper_rightZone__2F5EQ"};